import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "prescreenForm" }
const _hoisted_2 = { class: "gridRow" }
const _hoisted_3 = { class: "gridRow" }
const _hoisted_4 = { class: "gridRow" }
const _hoisted_5 = { class: "gridRow" }
const _hoisted_6 = { class: "buttonRow" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "infoRow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "buttonRow"
}
const _hoisted_13 = { class: "buttonRow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationErrors = _resolveComponent("ValidationErrors")!
  const _component_FormTextBox = _resolveComponent("FormTextBox")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PreScreenForm = _resolveComponent("PreScreenForm")!
  const _directive_cleave = _resolveDirective("cleave")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.error)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.step == 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('steps.contactInformation', {num: 1})), 1),
                _createVNode(_component_ValidationErrors, { errors: _ctx.validationErrors }, null, 8, ["errors"]),
                _createVNode(_component_Form, {
                  "validation-schema": _ctx.validationSchema,
                  onSubmit: _ctx.submitContactInfo,
                  onInvalidSubmit: _ctx.handleInvalid
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_FormTextBox, {
                        name: "firstName",
                        modelValue: _ctx.contactInfo.firstName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactInfo.firstName) = $event)),
                        langKey: "firstName",
                        required: true
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_FormTextBox, {
                        name: "lastName",
                        modelValue: _ctx.contactInfo.lastName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactInfo.lastName) = $event)),
                        langKey: "lastName",
                        required: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_FormTextBox, {
                        name: "email",
                        modelValue: _ctx.contactInfo.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactInfo.email) = $event)),
                        langKey: "email",
                        type: "email",
                        required: true
                      }, null, 8, ["modelValue"]),
                      _withDirectives(_createVNode(_component_FormTextBox, {
                        name: "dateOfBirth",
                        type: "date",
                        modelValue: _ctx.contactInfo.dateOfBirth,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactInfo.dateOfBirth) = $event)),
                        langKey: "dateOfBirth",
                        placeholder: "MM/DD/YYYY",
                        date: true,
                        required: true
                      }, null, 8, ["modelValue"]), [
                        [_directive_cleave, {date: true, datePattern: ['m', 'd', 'Y'], delimiter: '/'}]
                      ]),
                      _createVNode(_component_FormTextBox, {
                        name: "phoneNumber",
                        type: "phone",
                        modelValue: _ctx.contactInfo.phoneNumber,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactInfo.phoneNumber) = $event)),
                        langKey: "phoneNumber",
                        placeholder: "123-456-7890",
                        required: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_FormTextBox, {
                        name: "streetAddress",
                        modelValue: _ctx.contactInfo.address,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contactInfo.address) = $event)),
                        langKey: "streetAddress",
                        placeholder: "123 Main St",
                        required: true
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_FormTextBox, {
                        name: "apartmentNumber",
                        modelValue: _ctx.contactInfo.aptNumber,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contactInfo.aptNumber) = $event)),
                        langKey: "apartmentNumber",
                        placeholder: "Apt 1"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_FormTextBox, {
                        name: "zipCode",
                        modelValue: _ctx.contactInfo.zipCode,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contactInfo.zipCode) = $event)),
                        onInput: _ctx.validateZipCode,
                        langKey: "zipCode",
                        placeholder: "12345",
                        required: true
                      }, null, 8, ["modelValue", "onInput"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_FormTextBox, {
                        name: "city",
                        modelValue: _ctx.contactInfo.city,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contactInfo.city) = $event)),
                        langKey: "city",
                        disabled: true
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_FormTextBox, {
                        name: "state",
                        modelValue: _ctx.contactInfo.state,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contactInfo.state) = $event)),
                        langKey: "state",
                        disabled: true
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_FormTextBox, {
                        name: "county",
                        modelValue: _ctx.contactInfo.county,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contactInfo.county) = $event)),
                        langKey: "county",
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "button",
                        disabled: _ctx.isSubmitting
                      }, _toDisplayString(_ctx.$t('actions.next')), 9, _hoisted_7)
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onSubmit", "onInvalidSubmit"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.step == 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('steps.householdInformation', {num: 2})), 1),
                _createVNode(_component_ValidationErrors, { errors: _ctx.validationErrors }, null, 8, ["errors"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('name')), 1),
                    _createTextVNode(": " + _toDisplayString(_ctx.contactInfo.firstName) + " " + _toDisplayString(_ctx.contactInfo.lastName), 1),
                    _hoisted_9,
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('email')), 1),
                    _createTextVNode(": " + _toDisplayString(_ctx.contactInfo.email), 1),
                    _hoisted_10
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "secondaryButton",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('actions.startOver')), 1)
                  ])
                ]),
                _hoisted_11,
                _createVNode(_component_PreScreenForm, {
                  initialData: _ctx.initialPreScreenData,
                  "is-submitting": _ctx.isSubmitting,
                  onChange: _ctx.savePreScreenState,
                  onSubmit: _ctx.submitPreScreen,
                  onIneligible: _ctx.handleIneligible
                }, null, 8, ["initialData", "is-submitting", "onChange", "onSubmit", "onIneligible"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.step == 3)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('steps.complete')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('applicationComplete')), 1)
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('errors.heading')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.error)), 1),
          (_ctx.allowRetry)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "button",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetValidation && _ctx.resetValidation(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.$t('actions.back')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "secondaryButton",
              onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.$t('actions.startOver')), 1)
          ])
        ], 64))
  ]))
}